import { render, staticRenderFns } from "./CopiarDados.vue?vue&type=template&id=0d6b3f48&scoped=true&"
import script from "./CopiarDados.vue?vue&type=script&lang=js&"
export * from "./CopiarDados.vue?vue&type=script&lang=js&"
import style0 from "./CopiarDados.vue?vue&type=style&index=0&id=0d6b3f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b3f48",
  null
  
)

export default component.exports